import React from "react";
import { HelmetProvider, Helmet } from "react-helmet-async";
import "./App.css";
import Sidebar from "./components/sidebar/Sidebar";
import Home from "./components/home/Home";
// import About from "./components/about/About";
import Resume from "./components/experience/Resume";
import Portfolio from "./components/portfolio/Portfolio";
import { Analytics } from "@vercel/analytics/react";
import { SpeedInsights } from "@vercel/speed-insights/react";

import "./index.css";

const App = () => {
  return (
    <HelmetProvider>
      <>
        <Helmet>

          {/* Primary Meta Tags */}
          <title>Ivan Tsang - Software Engineer</title>
          <meta name="title" content="Ivan Tsang - Software Engineer & Developer Portfolio" />
          <meta name="description" content="Professional portfolio of Ivan Tsang - Experienced software engineer and developer showcasing projects, skills, and experience in web development and software engineering." />

          {/* Open Graph / Facebook */}
          <meta property="og:type" content="website" />
          <meta property="og:url" content="https://ivntsng.dev/" />
          <meta property="og:title" content="Ivan Tsang - Software Engineer & Developer Portfolio" />
          <meta property="og:description" content="Professional portfolio of Ivan Tsang - Experienced software engineer and developer showcasing projects, skills, and experience in web development and software engineering." />

          {/* Twitter */}
          <meta property="twitter:card" content="summary_large_image" />
          <meta property="twitter:url" content="https://ivntsng.dev/" />
          <meta property="twitter:title" content="Ivan Tsang - Software Engineer & Developer Portfolio" />
          <meta property="twitter:description" content="Professional portfolio of Ivan Tsang - Experienced software engineer and developer showcasing projects, skills, and experience in web development and software engineering." />

          {/* Additional SEO tags */}
          <meta name="keywords" content="ivan tsang, software engineer, web developer, portfolio, full stack developer, software development" />
          <meta name="author" content="Ivan Tsang" />
          <link rel="canonical" href="https://ivntsng.dev/" />
        </Helmet>
        <Sidebar />
        <main className="main">
          <Home />
          {/* <About /> */}
          <Resume />
          <Portfolio />
        </main>
        <Analytics />
        <SpeedInsights />
      </>
    </HelmetProvider>
  );
};

export default App;
